import {
  queryTipSettings as publicQueryTipSettings,
  typedQueryTipSettings as publicTypedQueryTipSettings,
  updateTipSettings as publicUpdateTipSettings,
  createTipSettings as publicCreateTipSettings,
  createDefaultTipSettings as publicCreateDefaultTipSettings,
  deleteTipSettings as publicDeleteTipSettings,
} from './tips-settings-v1-tip-settings-tip-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  TipSettingsQuery,
  TipSettingsQueryBuilder,
  typedQueryTipSettings as universalTypedQueryTipSettings,
} from './tips-settings-v1-tip-settings-tip-settings.universal.js';

function customQueryTipSettings(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryTipSettings(httpClient)(),
    typedQueryFunction: (query: TipSettingsQuery) =>
      publicTypedQueryTipSettings(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): TipSettingsQueryBuilder;
  function overloadedQuery(
    query: TipSettingsQuery
  ): ReturnType<typeof universalTypedQueryTipSettings>;
  function overloadedQuery(query?: TipSettingsQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const updateTipSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTipSettings> &
    typeof publicUpdateTipSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateTipSettings);
export const createTipSettings: MaybeContext<
  BuildRESTFunction<typeof publicCreateTipSettings> &
    typeof publicCreateTipSettings
> = /*#__PURE__*/ createRESTModule(publicCreateTipSettings);
export const createDefaultTipSettings: MaybeContext<
  BuildRESTFunction<typeof publicCreateDefaultTipSettings> &
    typeof publicCreateDefaultTipSettings
> = /*#__PURE__*/ createRESTModule(publicCreateDefaultTipSettings);
export const deleteTipSettings: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTipSettings> &
    typeof publicDeleteTipSettings
> = /*#__PURE__*/ createRESTModule(publicDeleteTipSettings);
export const queryTipSettings: MaybeContext<
  BuildRESTFunction<typeof customQueryTipSettings> &
    typeof customQueryTipSettings
> = /*#__PURE__*/ createRESTModule(customQueryTipSettings);

export {
  TipType,
  StaffDistributionMethod,
  SortOrder,
  WebhookIdentityType,
} from './tips-settings-v1-tip-settings-tip-settings.universal.js';
export {
  TipSettings,
  TipSettingsIdentifierOneOf,
  Preset,
  ExtendedFields,
  QueryTipSettingsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryTipSettingsResponse,
  PagingMetadataV2,
  Cursors,
  UpdateTipSettingsRequest,
  UpdateTipSettingsResponse,
  CreateTipSettingsRequest,
  CreateTipSettingsResponse,
  CreateDefaultTipSettingsRequest,
  CreateDefaultTipSettingsResponse,
  DeleteTipSettingsRequest,
  DeleteTipSettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  TipSettingsQueryResult,
  TipSettingsQueryBuilder,
  TipSettingsQuerySpec,
} from './tips-settings-v1-tip-settings-tip-settings.universal.js';
export { utils } from './tips-settings-v1-tip-settings-tip-settings.universal.js';
export {
  TipTypeWithLiterals,
  StaffDistributionMethodWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateTipSettingsApplicationErrors,
  CreateTipSettingsApplicationErrors,
  CreateDefaultTipSettingsApplicationErrors,
  DeleteTipSettingsApplicationErrors,
  CommonQueryWithEntityContext,
  TipSettingsQuery,
} from './tips-settings-v1-tip-settings-tip-settings.universal.js';
